import * as React from 'react';
import SquareActionButton from 'src/common-ui/components/Buttons/SquareActionButton';

export interface Props {
  hasFiltersSelected: boolean;
  areFiltersChanged: boolean;
  onClearAllFilters(): Promise<void>;
  onSubmitFilters(): Promise<void>;
}

export interface State {
  filters: {};
  isSubmitting: boolean;
}

export default class FiltersHeader extends React.PureComponent<Props, State> {
  state: State = {
    filters: {},
    isSubmitting: false,
  };

  constructor(props: Props) {
    super(props);
  }

  handleClear = async () => {
    this.setState({ isSubmitting: true });
    try {
      await this.props.onClearAllFilters();
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handleSubmit = async () => {
    this.setState({ isSubmitting: true });
    try {
      await this.props.onSubmitFilters();
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { hasFiltersSelected, areFiltersChanged } = this.props;
    const { isSubmitting } = this.state;

    return (
      <React.Fragment>
        <header className="d-flex flex-row justify-content-between">
          <div className="title-bar">
            <p className="title">Filters</p>
          </div>
        </header>
        <div className="main-action-container">
          <SquareActionButton
            onClick={this.handleClear}
            text="Clear"
            icon="far fa-ban"
            type="secondary"
            disabled={!hasFiltersSelected}
            loading={isSubmitting}
            dataQa="clear-button"
            className='clear'
          />
          <SquareActionButton
            onClick={this.handleSubmit}
            text="Submit"
            icon="far fa-check"
            type="primary"
            dataQa="submit-button"
            disabled={!areFiltersChanged}
            loading={isSubmitting}
            className='submit'
          />
        </div>
      </React.Fragment>
    );
  }
}
